<template>
    <div class="profile" :class="{ 'profile--collapsed': isCollapsed }">
        <el-tooltip :content="isCollapsed ? '展开用户画像' : '收起用户画像'" placement="left">
            <div class="profile-hand" @click="toggleCollapse">
                <i class="el-icon-d-arrow-right" style="font-size: 15px;" v-if="!isCollapsed"></i>
                <i class="el-icon-d-arrow-left" style="font-size: 15px;" v-else></i>
            </div>
        </el-tooltip>

        <div class="profile-content" v-show="!isCollapsed">
            <el-card class="profile-card" v-loading="userProfileLoading">
                <template #header>
                    <div class="card-header">
                        <div class="header-title">详情</div>
                        <div class="header-buttons">
                            <div v-if="isEditing.profile">
                                <el-button class="cancel-button header-buttons-mbutton" @click="cancelEdit('profile')">取消</el-button>
                                <el-button class="header-buttons-mbutton" type="primary" @click="saveProfile">保存</el-button>
                            </div>
                            <el-button v-else class="header-buttons-mbutton" type="primary" @click="toggleEdit('profile')">编辑</el-button>
                            <el-button v-if="!isEditing.profile" class="header-buttons-mbutton" type="primary" style="margin-left: 0;" @click="exportProfile">导出</el-button>
                        </div>
                    </div>
                </template>

                <el-form label-width="90px" size="small" class="profile-form">
                    <!-- 会话信息 -->
                    <div class="section-title">会话信息</div>
                    <el-form-item label="IP: ">
                        <div class="form-content">
                            <span >{{ cicadeStore?.WebEnv?.ip || '-' }}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="所在地: ">
                        <div class="form-content">
                            <span >{{ cicadeStore?.WebEnv?.cityInfo || '-' }}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="浏览器: ">
                        <div class="form-content">
                            <span >{{ cicadeStore?.WebEnv?.browser || '-' }}</span>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item label="内核: ">
                        <div class="form-content" style="text-overflow: ellipsis;overflow: hidden; white-space: nowrap !important;">
                            <span >{{ cicadeStore?.WebEnv?.userAgent || '-' }}</span>
                        </div>
                    </el-form-item> -->
                    <el-form-item label="操作系统: ">
                        <div class="form-content">
                            <span >{{ cicadeStore?.WebEnv?.os || '-' }}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="设备类型: ">
                        <div class="form-content">
                            <span >{{ cicadeStore?.WebEnv?.device || '-' }}</span>
                        </div>
                    </el-form-item>

                    <!-- 基本信息 -->
                    <div class="section-title">基本信息</div>
                    <el-form-item label="性别：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <span>{{ userProfile.basicInfo.gender || '-' }}</span>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-if="userProfile.basicInfo.gender" closable class="tag-item" @close="userProfile.basicInfo.gender = ''">
                                    {{ userProfile.basicInfo.gender }}
                                </el-tag>
                                <el-input v-if="inputVisible.gender" ref="genderInput" v-model="inputValue.gender" class="tag-input" size="small" @keyup.enter.native="handleInputConfirm('gender', 'basicInfo')" @blur="handleInputConfirm('gender', 'basicInfo')"> </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('gender')">+ 选择</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="年龄：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.basicInfo.age || '-' }}</span>
                            <el-input-number v-else v-model="userProfile.basicInfo.age" :min="0" :max="150" class="w-full"></el-input-number>
                        </div>
                    </el-form-item>

                    <el-form-item label="收入范围：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <span>{{ userProfile.basicInfo.incomeRange || '-' }}</span>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-if="userProfile.basicInfo.incomeRange" closable class="tag-item" @close="userProfile.basicInfo.incomeRange = ''">
                                    {{ userProfile.basicInfo.incomeRange }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.incomeRange"
                                    ref="incomeRangeInput"
                                    v-model="inputValue.incomeRange"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('incomeRange', 'basicInfo')"
                                    @blur="handleInputConfirm('incomeRange', 'basicInfo')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('incomeRange')">+ 选择</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="职业：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.basicInfo.occupation || '-' }}</span>
                            <el-input v-else v-model="userProfile.basicInfo.occupation" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="行业：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.basicInfo.industry || '-' }}</span>
                            <el-input v-else v-model="userProfile.basicInfo.industry" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="婚姻状况：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.basicInfo.maritalStatus || '-' }}</span>
                            <el-select v-else v-model="userProfile.basicInfo.maritalStatus" class="w-full">
                                <el-option label="未婚" value="未婚"></el-option>
                                <el-option label="已婚" value="已婚"></el-option>
                                <el-option label="离异" value="离异"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item label="所在地：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.basicInfo.location || '-' }}</span>
                            <el-input v-else v-model="userProfile.basicInfo.location" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="语言：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.basicInfo.language || '-' }}</span>
                            <el-input v-else v-model="userProfile.basicInfo.language" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <!-- 兴趣爱好 -->
                    <div class="section-title">兴趣爱好</div>
                    <el-form-item label="爱好：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.interest.hobbies.length">
                                        <el-tag v-for="hobby in userProfile.interest.hobbies" :key="hobby" class="tag-item">
                                            {{ hobby }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="hobby in userProfile.interest.hobbies" :key="hobby" closable class="tag-item" @close="removeTag(hobby, 'hobbies')">
                                    {{ hobby }}
                                </el-tag>
                                <el-input v-if="inputVisible.hobbies" ref="hobbyInput" v-model="inputValue.hobbies" class="tag-input" size="small" @keyup.enter.native="handleInputConfirm('hobbies', 'interest')" @blur="handleInputConfirm('hobbies', 'interest')"> </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('hobbies')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="投资风格：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <span>{{ userProfile.interest.investmentStyle || '-' }}</span>
                            </template>
                            <el-input v-else v-model="userProfile.interest.investmentStyle" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="投资产品：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.investmentProducts.length">
                                        <el-tag v-for="note in userProfile.investmentProducts" :key="note" class="tag-item">
                                            {{ note }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="note in userProfile.investmentProducts" :key="note" closable class="tag-item" @close="removeTag(note, 'investmentProducts')">
                                    {{ note }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.investmentProducts"
                                    ref="investmentProductsInput"
                                    v-model="inputValue.investmentProducts"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('investmentProducts', 'investmentProducts')"
                                    @blur="handleInputConfirm('investmentProducts', 'investmentProducts')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('investmentProducts')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="股票代码：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.stockPositionCode.length">
                                        <el-tag v-for="note in userProfile.stockPositionCode" :key="note" class="tag-item">
                                            {{ note }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="note in userProfile.stockPositionCode" :key="note" closable class="tag-item" @close="removeTag(note, 'stockPositionCode')">
                                    {{ note }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.stockPositionCode"
                                    ref="stockPositionCodeInput"
                                    v-model="inputValue.stockPositionCode"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('stockPositionCode', 'stockPositionCode')"
                                    @blur="handleInputConfirm('stockPositionCode', 'stockPositionCode')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('stockPositionCode')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="社交媒体：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.interest.socialMedia.length">
                                        <el-tag v-for="media in userProfile.interest.socialMedia" :key="media" class="tag-item">
                                            {{ media }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="media in userProfile.interest.socialMedia" :key="media" closable class="tag-item" @close="removeTag(media, 'socialMedia')">
                                    {{ media }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.socialMedia"
                                    ref="socialMediaInput"
                                    v-model="inputValue.socialMedia"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('socialMedia', 'interest')"
                                    @blur="handleInputConfirm('socialMedia', 'interest')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('socialMedia')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="关注话题：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.interest.topicsOfInterest.length">
                                        <el-tag v-for="topic in userProfile.interest.topicsOfInterest" :key="topic" class="tag-item">
                                            {{ topic }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="topic in userProfile.interest.topicsOfInterest" :key="topic" closable class="tag-item" @close="removeTag(topic, 'topicsOfInterest')">
                                    {{ topic }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.topicsOfInterest"
                                    ref="topicsInput"
                                    v-model="inputValue.topicsOfInterest"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('topicsOfInterest', 'interest')"
                                    @blur="handleInputConfirm('topicsOfInterest', 'interest')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('topicsOfInterest')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <!-- 行为特征 -->
                    <div class="section-title">行为特征</div>
                    <el-form-item label="联系方式：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.behavior.contactMethods.length">
                                        <el-tag v-for="method in userProfile.behavior.contactMethods" :key="method" class="tag-item">
                                            {{ method }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="method in userProfile.behavior.contactMethods" :key="method" closable class="tag-item" @close="removeTag(method, 'contactMethods')">
                                    {{ method }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.contactMethods"
                                    ref="contactMethodsInput"
                                    v-model="inputValue.contactMethods"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('contactMethods', 'behavior')"
                                    @blur="handleInputConfirm('contactMethods', 'behavior')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('contactMethods')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="生活经历：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.behavior.lifeExperiences.length">
                                        <el-tag v-for="exp in userProfile.behavior.lifeExperiences" :key="exp" class="tag-item">
                                            {{ exp }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="exp in userProfile.behavior.lifeExperiences" :key="exp" closable class="tag-item" @close="removeTag(exp, 'lifeExperiences')">
                                    {{ exp }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.lifeExperiences"
                                    ref="lifeExperiencesInput"
                                    v-model="inputValue.lifeExperiences"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('lifeExperiences', 'behavior')"
                                    @blur="handleInputConfirm('lifeExperiences', 'behavior')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('lifeExperiences')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <!-- 信任分析 -->
                    <div class="section-title">信任分析</div>
                    <el-form-item label="语气分析：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.trustAnalysis.toneAnalysis || '-' }}</span>
                            <el-input v-else v-model="userProfile.trustAnalysis.toneAnalysis" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="互动频率：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.trustAnalysis.interactionFrequency || '-' }}</span>
                            <el-input v-else v-model="userProfile.trustAnalysis.interactionFrequency" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="隐私披露：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.trustAnalysis.privacyDisclosure || '-' }}</span>
                            <el-input v-else v-model="userProfile.trustAnalysis.privacyDisclosure" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="信任等级：">
                        <div class="form-content">
                            <span v-if="!isEditing.profile">{{ userProfile.trustAnalysis.trustLevel || '-' }}</span>
                            <el-input v-else v-model="userProfile.trustAnalysis.trustLevel" class="w-full"></el-input>
                        </div>
                    </el-form-item>

                    <!-- 附加说明 -->
                    <div class="section-title">附加说明</div>
                    <el-form-item label="附加说明：">
                        <div class="form-content">
                            <template v-if="!isEditing.profile">
                                <div class="tag-container">
                                    <template v-if="userProfile.additionalNotes.length">
                                        <el-tag v-for="note in userProfile.additionalNotes" :key="note" class="tag-item">
                                            {{ note }}
                                        </el-tag>
                                    </template>
                                    <span v-else class="empty-text">暂无数据</span>
                                </div>
                            </template>
                            <div v-else class="dynamic-tags">
                                <el-tag v-for="note in userProfile.additionalNotes" :key="note" closable class="tag-item" @close="removeTag(note, 'additionalNotes')">
                                    {{ note }}
                                </el-tag>
                                <el-input
                                    v-if="inputVisible.additionalNotes"
                                    ref="additionalNotesInput"
                                    v-model="inputValue.additionalNotes"
                                    class="tag-input"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm('additionalNotes', 'additionalNotes')"
                                    @blur="handleInputConfirm('additionalNotes', 'additionalNotes')"
                                >
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput('additionalNotes')">+ 添加</el-button>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
    // 使用工厂函数返回全新的默认画像，避免共享引用导致被污染
    function createDefaultProfile() {
        return {
            attentionPoint: false,
            basicInfo: {
                gender: '',
                age: null,
                incomeRange: '',
                occupation: '',
                industry: '',
                maritalStatus: '',
                location: '',
                language: ''
            },
            interest: {
                hobbies: [],
                investmentStyle: '',
                socialMedia: [],
                topicsOfInterest: []
            },
            behavior: {
                contactMethods: [],
                lifeExperiences: []
            },
            trustAnalysis: {
                toneAnalysis: '',
                interactionFrequency: '',
                privacyDisclosure: '',
                trustLevel: ''
            },
            additionalNotes: [],
            investmentProducts: [],
            stockPositionCode: []
        };
    }
    export default {
        name: 'ChatUserProfile',
        props: {
            chat: {
                type: Object,
                default: () => {}
            },
            isCollapsed:{
                type: Boolean,
                //默认展开
                default: () => false
            }
        },
        data() {
            return {
                userProfileLoading: false,
                saving: false,
                isEditing: {
                    profile: false
                },
                userProfile: createDefaultProfile(),
                // 用于避免异步回调把旧请求结果写入当前视图
                profileLoadSeq: 0,
                incomeRanges: ['10万以下/年', '10-30万/年', '30-50万/年', '50-100万/年', '100万以上/年'],
                notesText: '',
                inputVisible: {
                    gender: false,
                    incomeRange: false,
                    investmentStyle: false,
                    hobbies: false,
                    socialMedia: false,
                    topicsOfInterest: false,
                    contactMethods: false,
                    lifeExperiences: false,
                    additionalNotes: false,
                    investmentProducts:false,
                    stockPositionCode:false
                },
                inputValue: {
                    gender: '',
                    incomeRange: '',
                    investmentStyle: '',
                    hobbies: '',
                    socialMedia: '',
                    topicsOfInterest: '',
                    contactMethods: '',
                    lifeExperiences: '',
                    additionalNotes: '',
                    investmentProducts:'',
                    stockPositionCode:''
                },
                backupData: null
            };
        },
        methods: {
            exportProfile(){
                this.$http({
                    url: "/client/exportChatHistory",
                    method: "post",
                    responseType: "blob",
                    data: {
                    type: "portrait",
                        account: this.cicadeStore.activeAccount.account,
                        channelName: this.cicadeStore.activeAccount.channelName,
                        chatIds: [this.cicadeStore.activeChat.chatId],
                    },
                })
                .then((messages) => {
                    const blob = new Blob([messages]);
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "用户画像.xlsx";
                    link.click();
                    URL.revokeObjectURL(url);
                })
            },
            toggleCollapse() {
                this.$emit('collapse', !this.isCollapsed);
            },
            toggleEdit(section) {
                if (!this.isEditing[section]) {
                    this.backupData = JSON.parse(JSON.stringify(this.userProfile));
                    if (section === 'notes') {
                        this.notesText = this.userProfile.additionalNotes.join('\n');
                    }
                } else {
                    this.backupData = null;
                }
                this.isEditing[section] = !this.isEditing[section];
            },
            cancelEdit(section) {
                if (this.backupData) {
                    this.userProfile = JSON.parse(JSON.stringify(this.backupData));
                    this.backupData = null;
                }
                this.isEditing[section] = false;
                Object.keys(this.inputVisible).forEach((key) => {
                    this.inputVisible[key] = false;
                    this.inputValue[key] = '';
                });
            },
            async saveProfile() {
                this.userProfileLoading = true;
                this.saving = true;
                const savingChatId = this.cicadeStore?.activeChat?.chatId;
                var _this = this;
                try {
                    // 这里添加保存逻辑
                    await this.$store.dispatch('updateUserProfile', {
                        userProfile: this.convertKeysToCamelCase(this.userProfile),
                        callback: () => {
                            // 仅当仍停留在同一会话时才应用保存后的更新
                            if (_this.cicadeStore?.activeChat?.chatId === savingChatId) {
                                _this.$message.success('保存成功!');
                                _this.toggleEdit('profile');
                                // 保存完成后重新拉取当前会话画像（并再次加序列防抖）
                                const seq = ++_this.profileLoadSeq;
                                _this.$store.dispatch('loadUserProfile', (data) => {
                                    if (seq === _this.profileLoadSeq && _this.cicadeStore?.activeChat?.chatId === savingChatId) {
                                        _this.initUserProfile(data);
                                    }
                                    _this.userProfileLoading = false;
                                });
                            }
                            _this.saving = false;
                        }
                    });
                } catch (error) {
                    this.$message.error('保存失败');
                } finally {
                    this.userProfileLoading = false;
                    this.saving = false;
                }
            },
            showInput(type) {
                this.inputVisible[type] = true;
                this.$nextTick(() => {
                    this.$refs[type + 'Input'].$refs.input.focus();
                });
            },
            handleInputConfirm(type, section) {
                console.log(type, section);
                const inputValue = this.inputValue[type];
                if (inputValue) {
                    if (type === 'additionalNotes') {
                        if (!this.userProfile.additionalNotes.includes(inputValue)) {
                            this.userProfile.additionalNotes.push(inputValue);
                        }
                    } else if(type === 'investmentProducts') {
                        if (!this.userProfile.investmentProducts.includes(inputValue)) {
                            this.userProfile.investmentProducts.push(inputValue);
                        }
                    } else if(type === 'stockPositionCode') {
                        if (!this.userProfile.stockPositionCode.includes(inputValue)) {
                            this.userProfile.stockPositionCode.push(inputValue);
                        }
                    } else if (Array.isArray(this.userProfile[section][type])) {
                        if (!this.userProfile[section][type].includes(inputValue)) {
                            this.userProfile[section][type].push(inputValue);
                        }
                    } else {
                        this.userProfile[section][type] = inputValue;
                    }
                }
                this.inputVisible[type] = false;
                this.inputValue[type] = '';
            },
            removeTag(tag, type) {
                let targetArray;
                switch (type) {
                    case 'hobbies':
                        targetArray = this.userProfile.interest.hobbies;
                        break;
                    case 'socialMedia':
                        targetArray = this.userProfile.interest.socialMedia;
                        break;
                    case 'topicsOfInterest':
                        targetArray = this.userProfile.interest.topicsOfInterest;
                        break;
                    case 'contactMethods':
                        targetArray = this.userProfile.behavior.contactMethods;
                        break;
                    case 'lifeExperiences':
                        targetArray = this.userProfile.behavior.lifeExperiences;
                        break;
                    case 'additionalNotes':
                        targetArray = this.userProfile.additionalNotes;
                        break;
                    case 'investmentProducts':
                        targetArray = this.userProfile.investmentProducts;
                        break;
                    case 'stockPositionCode':
                        targetArray = this.userProfile.stockPositionCode;
                    break;
                }
                const index = targetArray.indexOf(tag);
                if (index > -1) {
                    targetArray.splice(index, 1);
                }
            },
            toCamelCase(str) {
                return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
            },
            // 下划线转驼峰
            convertKeysToCamelCase(obj) {
                if (Array.isArray(obj)) {
                    return obj.map((item) => this.convertKeysToCamelCase(item));
                } else if (obj !== null && typeof obj === 'object') {
                    return Object.keys(obj).reduce((acc, key) => {
                        const camelCaseKey = this.toCamelCase(key);
                        acc[camelCaseKey] = this.convertKeysToCamelCase(obj[key]);
                        return acc;
                    }, {});
                } else {
                    return obj;
                }
            },
            initUserProfile(data) {
                if (!data) {
                    return;
                }
                // 每次初始化都使用全新的默认模板，避免默认值被上一次编辑污染
                const defaultProfile = createDefaultProfile();
                this.userProfile = {
                    attentionPoint: data.attentionPoint,
                    basicInfo: {
                        gender: data.basicInfo?.gender || defaultProfile.basicInfo.gender,
                        age: data.basicInfo?.age || defaultProfile.basicInfo.age,
                        incomeRange: data.basicInfo?.incomeRange || defaultProfile.basicInfo.incomeRange,
                        occupation: data.basicInfo?.occupation || defaultProfile.basicInfo.occupation,
                        industry: data.basicInfo?.industry || defaultProfile.basicInfo.industry,
                        maritalStatus: data.basicInfo?.maritalStatus || defaultProfile.basicInfo.maritalStatus,
                        location: data.basicInfo?.location || defaultProfile.basicInfo.location,
                        language: data.basicInfo?.language || defaultProfile.basicInfo.language
                    },
                    interest: {
                        hobbies: data.interest?.hobbies || defaultProfile.interest.hobbies,
                        investmentStyle: data.interest?.investmentStyle || defaultProfile.interest.investmentStyle,
                        socialMedia: data.interest?.socialMedia || defaultProfile.interest.socialMedia,
                        topicsOfInterest: data.interest?.topicsOfInterest || defaultProfile.interest.topicsOfInterest
                    },
                    behavior: {
                        contactMethods: data.behavior?.contactMethods || defaultProfile.behavior.contactMethods,
                        lifeExperiences: data.behavior?.lifeExperiences || defaultProfile.behavior.lifeExperiences
                    },
                    trustAnalysis: {
                        toneAnalysis: data.trustAnalysis?.toneAnalysis || defaultProfile.trustAnalysis.toneAnalysis,
                        interactionFrequency: data.trustAnalysis?.interactionFrequency || defaultProfile.trustAnalysis.interactionFrequency,
                        privacyDisclosure: data.trustAnalysis?.privacyDisclosure || defaultProfile.trustAnalysis.privacyDisclosure,
                        trustLevel: data.trustAnalysis?.trustLevel || defaultProfile.trustAnalysis.trustLevel
                    },
                    additionalNotes: data.additionalNotes || defaultProfile.additionalNotes,
                    investmentProducts: data.investmentProducts || defaultProfile.investmentProducts,
                    stockPositionCode: data.stockPositionCode || defaultProfile.stockPositionCode,
                };
            }
        },
        watch: {
            chat: {
                handler(newChat) {
                    if (newChat) {
                        this.userProfileLoading = true;
                        // 先重置为干净的默认对象，避免短暂显示上一个用户的数据
                        this.userProfile = createDefaultProfile();
                        Object.keys(this.inputVisible).forEach((key) => {
                            this.inputVisible[key] = false;
                            this.inputValue[key] = '';
                        });
                        // 递增序列号，后到的旧回调会被丢弃
                        const seq = ++this.profileLoadSeq;
                        const expectedChatId = this.cicadeStore?.activeChat?.chatId;
                        this.$store.dispatch('loadUserProfile', (data) => {
                            if (seq === this.profileLoadSeq && this.cicadeStore?.activeChat?.chatId === expectedChatId) {
                                this.initUserProfile(data);
                            }
                            this.userProfileLoading = false;
                        });
                        this.$store.dispatch('loadUserWebEnv')
                    }
                },
                immediate: true
            }
        },
        computed: {
            ...mapState(["cicadeStore"]),
        },
    };
</script>

<style lang="scss" scoped>
    .profile {
        border-left: 1px solid #e5e5e5;
        position: relative;
        width: 18vw;
        height: 100%;
        transition: all 0.3s ease;
        padding-bottom: 120px;
        background: #f7f8fa;

        &--collapsed {
            width: 0px;
        }

        &-hand {
            position: absolute;
            left: -21px;
            top: 30%;
            transform: translateY(-50%);
            cursor: pointer;
            // z-index: 1;
            width: 20px;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border-radius: 50px 0 0 50px;
            border: 1px solid #e5e5e5;
            transition: all 0.3s ease;
            color: #606266;

            &:hover {
                background-color: #f5f7fa;
                color: #409eff;
            }

            i {
                font-size: 20px;
                color: var(--im-color-primary-light-4);
            }
        }

        &-content {
            height: 100%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #dcdfe6;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-track {
                background: #f5f7fa;
            }
        }

        &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
            padding: 0 4px;

            h2 {
                margin: 0;
                font-weight: 600;
                color: #303133;
                font-size: 20px;
            }
        }

        &-card {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);
            border: none;
            transition: all 0.3s ease;

            &:hover {
                box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.06);
            }
        }
    }

    .card-header {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        .header-title{
            font-size: 18px;
        }

        .el-button {
            padding: 0;
            font-weight: normal;
            font-size: 14px;

            // &:hover {
            //     color: #409eff;
            // }
        }
    }

    .tag-container {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
    }
    .form-content {
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        white-space: pre-wrap !important;
        word-break: break-all !important;
        overflow-wrap: break-word !important;
        text-align: left;
    }

    .tag-item {
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 4px;
        background-color: #f0f2f5;
        border-color: transparent;
        color: #606266;
        padding: 0 12px;
        height: 28px;
        line-height: 26px;
        font-size: 13px;

        &:hover {
            background-color: #e6e8eb;
        }
    }

    :deep(.el-form) {
        .el-form-item {
            margin-bottom: 8px !important;

            &:last-child {
                margin-bottom: 0;
            }
        }

        .el-form-item__label {
            font-weight: 500;
            color: #606266;
            font-size: 14px;
            padding-right: 12px;
        }

        .el-form-item__content {
            line-height: 32px;
            font-size: 14px;
        }

        .el-input__inner {
            border-radius: 6px;
        }
    }

    :deep(.el-select) {
        width: 100%;
    }

    :deep(.el-input-number) {
        width: 120px;
    }

    :deep(.el-select-dropdown__item) {
        padding: 0 12px;
    }

    :deep(.el-button--primary) {
        border-radius: 6px;
        padding: 8px 16px;
        font-size: 14px;
        font-weight: 500;
    }

    :deep(.el-card__header){
        height: 50px !important;
        padding: 0 20px;
    }

    .dynamic-tags {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        min-height: 32px;
    }

    .tag-input {
        width: 90px;
        margin-right: 8px;
        vertical-align: bottom;
    }

    .button-new-tag {
        height: 28px;
        padding: 0 8px;
        font-size: 12px;
        color: #409eff;
        border-color: #409eff;
        background: transparent;

        &:hover {
            color: #fff;
            background-color: #409eff;
        }
    }

    .tag-item {
        position: relative;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 0px;
        border-radius: 4px;
        background-color: #f0f2f5;
        border-color: transparent;
        color: #606266;
        padding: 0 18px 0 8px;
        height: 28px;
        line-height: 26px;
        font-size: 13px;

        &:hover {
            background-color: #e6e8eb;
        }

        .el-icon-close {
            color: #909399;
            font-weight: bold;

            &:hover {
                color: #409eff;
            }
        }
    }

    .header-buttons {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .header-buttons-mbutton{
        padding: 5px 12px !important;
        font-size: 13px !important;
    }

    .cancel-button {
        color: #909399 !important;

        &:hover {
            color: #606266 !important;
        }
    }

    .empty-text {
        color: #909399;
        font-size: 14px;
        line-height: 32px;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin: 24px 0 16px;
        padding-left: 8px;
        border-left: 3px solid #409eff;
        text-align: left;

        &:first-child {
            margin-top: 0;
        }
    }

    :deep(.el-icon-close) {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0,-50%);
    }
</style>
